
import { useState, useEffect } from   'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, InputGroup, Form, Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import moment from 'moment';
import SweetAlert2 from 'react-sweetalert2';
import { FaMarker, FaUsers } from 'react-icons/fa';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';
import { useAuth } from '../../Auth/AuthContext';
import apiService from '../../Auth/apiService';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Tooltip } from 'react-tooltip';
import { getMunicipiosDX, saveMunicipiosDX } from '../Utils/indexedDBUtils';
import { useForm } from 'react-hook-form';
import { setTipoMovilidad } from '../Utils/SetTipoMovilidad';
import * as XLSX from 'xlsx';
import './Revisiondx.css';


export default function Revisiondx() {
    const { token } = useAuth();
    const minDate = new Date(2019, 4, 30);
    const maxDate = new Date();
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [swalProps, setSwalProps] = useState({});
    const [fechaFin, setFechaFin] = useState(new Date());
    const navigate = useNavigate();
    const [Cargando, setCargando] = useState(false);
    const [diagnosticos, setDiagnosticos] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [barrios, setBarrios] = useState([]);
    const [actoresarmados, setActoresarmados] = useState([]);
    const [tiposMovilidad, setTiposMovilidad] = useState([]);
    const [filaSeleccionada, setFilaSeleccionada] = useState(null);
    const [lugarExacto, setLugarExacto] = useState([]);
    const [infoModal, setInfoModal] = useState({
        show: false,
        content: {}
    })
    const { watch, handleSubmit, register, setValue, reset, formState: { errors }} = useForm({ 
            defaultValues: {
                iddx: '',
            } 
        }
        );
    const exportarExcel = () => {
        // Convierte los datos a una hoja de Excel
        const worksheet = XLSX.utils.json_to_sheet(diagnosticos);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Diagnosticos");
        // Descarga el archivo
        XLSX.writeFile(workbook, "diagnosticos.xlsx");
    };
    const Mensaje = (title, text, icon) => {
        setSwalProps({
            show: true,
            title: title,
            html: text,
            icon: icon,
        });
    };
    const MostrarFormularioDiagnostico = (row) =>  {
        navigate(`/dx/identificacion/${row.id}/${row.recepcionid}`);
      };
    async function fetchMunicipiosDX() {
        const url = '/diagnostico/obtenermunicipiosdx';
        return apiService.get(url, token)
            .then((response) => {
                if (Array.isArray(response.data.municipiosdx)) {
                    return response.data.municipiosdx;   
                }
                return null;
            })
            .catch((error) => {
                console.error('Error fetching municipios:', error);
                return null;
            });
    }
    async function getMunicipiosDXData() {
        const cachedmunicipiosDX = await getMunicipiosDX();
        if (cachedmunicipiosDX) {
            setMunicipios(cachedmunicipiosDX);
        } else {
            const municipios = await fetchMunicipiosDX();
            if (municipios) {
                setMunicipios(municipios);
                await saveMunicipiosDX(municipios);
            }
        }
    }
    const revisioDx = (row) =>  {
        setInfoModal({
            show: true,
            content: {
                id: row.id,
                dx_fecha: row.dx_fecha ?? row.dxFecha ?? '',
                id_1_1_1_p_nombre: row.id_1_1_1_p_nombre ?? row.id111PNombre ?? '',
                id_1_1_2_s_nombre: row.id_1_1_2_s_nombre ?? row.id112SNombre ?? '',
                id_1_1_3_p_apellido: row.id_1_1_3_p_apellido ?? row.id113PApellido ?? '',
                id_1_1_4_s_apellido: row.id_1_1_4_s_apellido ?? row.id114SApellido ?? '',
                id_1_2_2_n_documento: row.id_1_2_2_n_documento ?? row.id122NDocumento ?? '',
                dx_7_1_nombre_responsable_atencion: row.dx_7_1_nombre_responsable_atencion ?? row.dx71NombreResponsableAtencion ?? '',
            }   
        })
        reset((prevvalues) => ({
            ...prevvalues,
            iddx: row.id,
            vict_4_5_fecha_hecho: row.vict_4_5_fecha_hecho ?? row.vict45FechaHecho ?? '',
            vict_4_4_2_municipio: row.vict_4_4_2_municipio ?? row.vict442Municipio ?? '',
            vict_4_4_4_lugar_exacto_del_municipio: row.vict_4_4_4_lugar_exacto_del_municipio ?? row.vict444LugarExactoDelMunicipio ?? '',
            vict_4_4_5_nombre_tipo_entorno: row.vict_4_4_5_nombre_tipo_entorno ?? row.vict445NombreTipoEntorno ?? '',
            vict_4_4_8_hecho_intraurbano_barrio: row.vict_4_4_8_hecho_intraurbano_barrio ?? row.vict448HechoIntraurbanoBarrio ?? '',
            vict_4_4_9_hecho_intraurbano_sector_o_asentamiento: row.vict_4_4_9_hecho_intraurbano_sector_o_asentamiento ?? row.vict449HechoIntraurbanoSectorOAsentamiento ?? '',
            vict_4_4_10_hecho_intraurbano_direccion: row.vict_4_4_10_hecho_intraurbano_direccion ?? row.vict4410HechoIntraurbanoDireccion ?? '',
            ubi_3_2_barrio_o_vereda: row.ubi_3_2_barrio_o_vereda ?? row.ubi32BarrioOVereda ?? '',
            ubi_3_3_asentamiento_o_sector: row.ubi_3_3_asentamiento_o_sector ?? row.ubi33AsentamientoOSector ?? '',
            ubi_3_4_direccion: row.ubi_3_4_direccion ?? row.ubi34Direccion ?? '',
            vict_4_2_actor_armado_ocasiono_el_hecho_victimizante: row.vict_4_2_actor_armado_ocasiono_el_hecho_victimizante ?? row.vict42ActorArmadoOcasionoElHechoVictimizante ?? '',
            vict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante: row.vict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante ?? row.vict421ActorArmadoOcasionoElHechoVictimizante ?? '',
            vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar: row.vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar ?? row.vict4211SiLaRespuestaAnteriorEsOtrosCualIdentificar ?? '',
            vict_4_1_3_desplazamiento_forzado: row.vict_4_1_3_desplazamiento_forzado ?? row.vict413DesplazamientoForzado ?? '0',
            vict_4_1_4_homicidio: row.vict_4_1_4_homicidio ?? row.vict414Homicidio ?? '0',
            vict_4_1_5_masacre: row.vict_4_1_5_masacre ?? row.vict415Masacre ?? '0',
            vict_4_1_6_tortura_o_tratos_inhumanos_degradantes: row.vict_4_1_6_tortura_o_tratos_inhumanos_degradantes ?? row.vict416TorturaOTratosInhumanosDegradantes ?? '0',
            vict_4_1_7_lesiones_permanentes_o_transitorias: row.vict_4_1_7_lesiones_permanentes_o_transitorias ?? row.vict417LesionesPermanentesOTransitorias ?? '0',
            vict_4_1_8_minas_antipersonal_municiones_sin_explotar: row.vict_4_1_8_minas_antipersonal_municiones_sin_explotar ?? row.vict418MinasAntipersonalMunicionesSinExplotar ?? '0',
            vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual: row.vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual ?? row.vict419DelitosContraLaLibertadYLaIntegridadSexual ?? '0',
            vict_4_1_10_1_intento_de_reclutamiento: row.vict_4_1_10_1_intento_de_reclutamiento ?? row.vict41101IntentoDeReclutamiento ?? '0',
            vict_4_1_10_2_reclutamiento_y_utilizacion: row.vict_4_1_10_2_reclutamiento_y_utilizacion ?? row.vict41102ReclutamientoYUtilizacion ?? '0',
            vict_4_1_11_acto_terrorista: row.vict_4_1_11_acto_terrorista ?? row.vict4111ActoTerrorista ?? '0',
            vict_4_1_12_amenaza: row.vict_4_1_12_amenaza ?? row.vict4112Amenaza ?? '0',
            vict_4_1_13_despojo_y_abandono_forzado_de_tierras: row.vict_4_1_13_despojo_y_abandono_forzado_de_tierras ?? row.vict4113DespojoYAbandonoForzadoDeTierras ?? '0',
            vict_4_7_observaciones: row.vict_4_7_observaciones ?? row.vict47Observaciones ?? '',
            vict_4_4_6_tipo_movilidad: row.vict_4_4_6_tipo_movilidad ?? row.vict446TipoMovilidad ?? '',
            departamentoHecho: municipios.find(m => m.id === (row.vict_4_4_2_municipio ?? row.vict442Municipio).toString())?.mun_departamento ?? '',
            vict_4_4_3_subregion_antioquia: row.vict_4_4_3_subregion_antioquia ?? row.vict443SubregionAntioquia ?? municipios.find(m => m.id === (row.vict_4_4_2_municipio ?? row.vict442Municipio).toString())?.mun_subregion ?? '',
            vict_4_4_7_hecho_intraurbano_comuna_o_corregimiento: row.vict_4_4_7_hecho_intraurbano_comuna_o_corregimiento ?? row.vict447HechoIntraurbanoComunaOCorregimiento ?? '',
            ubi_3_1_comuna_o_corregimiento: row.ubi_3_1_comuna_o_corregimiento ?? row.ubi31ComunaOCorregimiento ?? '',
            vict_4_4_1_departamento : row.vict_4_4_1_departamento ?? row.vict441Departamento ?? '',
        }));
    }    
    useEffect(() => {
        getMunicipiosDXData()
    }, []);
    const buscarDxs = async () => {
        setCargando(true);
        const url = '/diagnostico/consultardxrevisionporfecha';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setDiagnosticos(response.data.diagnosticos)
                setLugarExacto(response.data.lugaresexpulsores)
                setBarrios(response.data.barrios)
                setActoresarmados(response.data.actoresarmados)
                setTiposMovilidad(response.data.tiposmovilidad)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const buscarDxsDocumento = async () => {
        setCargando(true);
        const url = '/diagnostico/consultardxrevisionporfecha';
        const obj = {
            fechaInicio: fechaInicio ? fechaInicio.toLocaleDateString('en-CA') : null,
            fechaFin: fechaFin ? fechaFin.toLocaleDateString('en-CA') : null,
            idPersona: watch('documento')
        };
        try {
            const response = await apiService.post(url, obj, token);
            if (response.status === 200) {
                setDiagnosticos(response.data.diagnosticos)
                setLugarExacto(response.data.lugaresexpulsores)
                setBarrios(response.data.barrios)
                setActoresarmados(response.data.actoresarmados)
                setTiposMovilidad(response.data.tiposmovilidad)
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const guardarDxRevision = async (data) => {
        setCargando(true);
        let url;
        url = '/diagnostico/guardarrevisiondx';
        try {
            data.vict_4_5_fecha_hecho = (moment(fechaHechoDate).isValid()) ? moment(fechaHechoDate).format('YYYY-MM-DD') : null;
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar', JSON.stringify(response.data.message), 'success');
                setInfoModal({ show: false, content: {} }); // Oculta el formulario
                reset(); // Limpia los datos del formulario
                buscarDxs(); // Refresca la lista de diagnósticos
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors), 'error');
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data), 'error');
            }else{
                Mensaje('Guardar', JSON.stringify(error.response.data), 'error');
                console.error('Error fetching data:', error);
            }
            
        } finally {
            setCargando(false);
        }
    };
    const fechaHechoValue = watch('vict_4_5_fecha_hecho');
    const fechaHechoDate = fechaHechoValue
        ? moment(fechaHechoValue, 'YYYY-MM-DD').toDate()
        : null;
    const vict_4_4_2_municipio = watch('vict_4_4_2_municipio');
    const vict_4_4_4_lugar_exacto_del_municipio = watch('vict_4_4_4_lugar_exacto_del_municipio');
    const vict_4_4_5_nombre_tipo_entorno = watch('vict_4_4_5_nombre_tipo_entorno');
    const vict_4_4_8_hecho_intraurbano_barrio = watch('vict_4_4_8_hecho_intraurbano_barrio');
    const vict_4_4_9_hecho_intraurbano_sector_o_asentamiento = watch('vict_4_4_9_hecho_intraurbano_sector_o_asentamiento');
    const vict_4_4_10_hecho_intraurbano_direccion = watch('vict_4_4_10_hecho_intraurbano_direccion');
    const ubi_3_2_barrio_o_vereda = watch('ubi_3_2_barrio_o_vereda');
    const ubi_3_3_asentamiento_o_sector = watch('ubi_3_3_asentamiento_o_sector');
    const ubi_3_4_direccion = watch('ubi_3_4_direccion');
    const vict_4_2_actor_armado_ocasiono_el_hecho_victimizante = watch('vict_4_2_actor_armado_ocasiono_el_hecho_victimizante');
    const vict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante = watch('vict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante');
    const vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar = watch('vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar');
    const vict_4_1_3_desplazamiento_forzado = watch('vict_4_1_3_desplazamiento_forzado');
    const vict_4_1_4_homicidio = watch('vict_4_1_4_homicidio');
    const vict_4_1_5_masacre = watch('vict_4_1_5_masacre');
    const vict_4_1_6_tortura_o_tratos_inhumanos_degradantes = watch('vict_4_1_6_tortura_o_tratos_inhumanos_degradantes');
    const vict_4_1_7_lesiones_permanentes_o_transitorias = watch('vict_4_1_7_lesiones_permanentes_o_transitorias');
    const vict_4_1_8_minas_antipersonal_municiones_sin_explotar     = watch('vict_4_1_8_minas_antipersonal_municiones_sin_explotar');
    const vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual = watch('vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual');
    const vict_4_1_10_1_intento_de_reclutamiento = watch('vict_4_1_10_1_intento_de_reclutamiento');
    const vict_4_1_10_2_reclutamiento_y_utilizacion = watch('vict_4_1_10_2_reclutamiento_y_utilizacion');
    const vict_4_1_11_acto_terrorista = watch('vict_4_1_11_acto_terrorista');
    const vict_4_1_12_amenaza = watch('vict_4_1_12_amenaza');
    const vict_4_1_13_despojo_y_abandono_forzado_de_tierras = watch('vict_4_1_13_despojo_y_abandono_forzado_de_tierras');
    const vict_4_7_observaciones = watch('vict_4_7_observaciones');
    const [filters, setFilters] = useState({
        documento: '',
        primerNombre: '',
        primerApellido: '',
        municipio: '',
        fecha: ''
    });
    const filteredDiagnosticos = diagnosticos.filter(row =>
        (!filters.id || row.id?.toString().includes(filters.id)) &&
        (!filters.documento || (row.id_1_2_2_n_documento ?? row.id122NDocumento ?? '').toString().includes(filters.documento)) &&
        (!filters.primerNombre || (row.id_1_1_1_p_nombre ?? row.id111PNombre ?? '').toLowerCase().includes(filters.primerNombre.toLowerCase())) &&
        (!filters.primerApellido || (row.id_1_1_3_p_apellido ?? row.id113PApellido ?? '').toLowerCase().includes(filters.primerApellido.toLowerCase())) &&
        (!filters.municipio || (row.municipio_hecho ?? '').toLowerCase().includes(filters.municipio.toLowerCase())) &&
        (!filters.fecha || (row.dx_fecha ?? row.dxFecha ? new Date(row.dx_fecha ?? row.dxFecha).toISOString().split('T')[0] : '').includes(filters.fecha))
    );
    return (
        <div className="content-wrapper">
             <SeccionPageHeader
                title="Diag&oacute;stico base - Revisi&oacute;n de diagn&oacute;stico"
                idCabezaFamilia="1"
                url="/dx/diagnosticodx"
                nombreurl="Diagnostico dx"
                nombreform="Revision de diagnostico"
            />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div id="formDiagnostico" className="card">
                    
                    <div className="row">
                    <div className="col-md-12">
                        <div className="tab-content">
                            <div className="card mb-4">
                                <div className="card-header">
                                    <h5 className="mb-0">Listado de diagn&oacute;sticos</h5>
                                </div>
                                <div className='row mb-3'>
                                    <div className='col-md-4'>
                                        <div className="card-body">
                                            <h5 className="mb-12">Por documento</h5>
                                            <Row className="mb-12">
                                                <Col md={12}>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Número de documento"
                                                        {...register('documento')}
                                                        autoComplete="off"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col md={12}>
                                                    <Button variant="primary" onClick={buscarDxsDocumento}>
                                                        Buscar
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <div className='col-md-8'>
                                        <div className="card-body">
                                            <h5 className="mb-12">Por fechas</h5>
                                            <Row className="mb-12">
                                                <Col md={4}>
                                                    <InputGroup>
                                                        <InputGroup.Text>Fecha inicio</InputGroup.Text>
                                                        <DatePicker
                                                            selected={fechaInicio}
                                                            onChange={date => setFechaInicio(date)}
                                                            minDate={minDate}
                                                            maxDate={fechaFin || maxDate}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            placeholderText="Seleccione fecha inicio"
                                                        />
                                                    </InputGroup>
                                                </Col>
                                                <Col md={4}>
                                                    <InputGroup>
                                                        <InputGroup.Text>Fecha fin</InputGroup.Text>
                                                        <DatePicker
                                                            selected={fechaFin}
                                                            onChange={date => setFechaFin(date)}
                                                            minDate={fechaInicio || minDate}
                                                            maxDate={maxDate}
                                                            dateFormat="dd/MM/yyyy"
                                                            className="form-control"
                                                            placeholderText="Seleccione fecha fin"
                                                        />
                                                    </InputGroup>
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col md={4}>
                                                    <Button variant="primary" onClick={buscarDxs}>
                                                        Buscar
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                                <div className='card-body'>
                                    <Button variant="success" onClick={exportarExcel} className="mb-2">
                                        Exportar Excel
                                    </Button>
                                    <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                        <table className="table table-bordered table-hover table-sm">
                                            <thead className="thead-light">
                                            <tr>
                                                <th>Acciones</th>
                                                <th>Id</th>
                                                <th>Fecha</th>
                                                <th>Primer Nombre</th>
                                                <th>Segundo Nombre</th>
                                                <th>Primer Apellido</th>
                                                <th>Segundo Apellido</th>
                                                <th>tipo documento</th>
                                                <th>Documento</th>
                                                <th>Comuna arribo</th>
                                                <th>Barrio arribo</th>
                                                <th>Sector arribo</th>
                                                <th>Direccion arribo</th>
                                                <th>Departamento</th>
                                                <th>Municipio</th>
                                                <th>Subregion</th>
                                                <th>Lugar exacto</th>
                                                <th>Entorno</th>
                                                <th>Tipo movilidad</th>
                                                <th>Comuna hecho</th>
                                                <th>Barrio hecho</th>
                                                <th>Sector hecho</th>
                                                <th>Dirección hecho</th>
                                                <th>Fecha ocurrencia</th>
                                                <th>Desplazamiento</th>
                                                <th>Homicidio</th>
                                                <th>Masacre</th>
                                                <th>Tortura</th>
                                                <th>Lesiones</th>
                                                <th>Minas</th>
                                                <th>Delito sexual</th>
                                                <th>Intento reclutamiento</th>
                                                <th>Reclutamiento</th>
                                                <th>Acto terrorista</th>
                                                <th>Amenaza</th>
                                                <th>Despojo tierras</th>
                                                <th>Actor armado 1</th>
                                                <th>Actor armado 2</th>
                                                <th>Otro actor armado</th>
                                                <th>Responsable</th>
                                            </tr>
                                            <tr>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Fecha"
                                                        value={filters.fecha}
                                                        onChange={e => setFilters(f => ({ ...f, fecha: e.target.value }))}
                                                    />
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="Documento"
                                                        value={filters.documento}
                                                        onChange={e => setFilters(f => ({ ...f, documento: e.target.value }))}
                                                    />
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th>
                                                    <select
                                                        className="form-control form-control-sm"
                                                        value={filters.municipio}
                                                        onChange={e => setFilters(f => ({ ...f, municipio: e.target.value }))}
                                                    >
                                                        <option value="">Todos</option>
                                                        {[...municipios]
                                                            .sort((a, b) => a.mun_municipio.localeCompare(b.mun_municipio))
                                                            .map(m => (
                                                                <option key={m.id} value={m.mun_municipio}>
                                                                    {m.mun_municipio} - {m.mun_departamento}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {filteredDiagnosticos.length === 0 ? (
                                                <tr>
                                                <td colSpan={39} className="text-center">No hay diagnosticos para mostrar</td>
                                                </tr>
                                            ) : (
                                                filteredDiagnosticos.map((row) => (
                                                <tr
                                                    key={row.id}
                                                    className={row.id === filaSeleccionada ? 'selected-row' : ''}
                                                    onClick={() => setFilaSeleccionada(row.id)}
                                                >
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>
                                                    <div>
                                                        <InputGroup className="me-2" style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
                                                        <button
                                                            type="button"
                                                            onClick={() => MostrarFormularioDiagnostico(row)}
                                                            style={{ backgroundColor: 'skyblue' }}
                                                            data-tooltip-id='tooltiparriba'
                                                            data-tooltip-content="Ver diagnostico"
                                                        >
                                                            <FaUsers />
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => revisioDx(row)}
                                                            style={{ backgroundColor: 'skyblue' }}
                                                            data-tooltip-id='tooltiparriba'
                                                            data-tooltip-content="Revisar diagnostico"
                                                        >
                                                            <FaMarker />
                                                        </button>
                                                        </InputGroup>
                                                    </div>
                                                    </td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.id}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.dx_fecha ?? row.dxFecha ? new Date(row.dx_fecha ?? row.dxFecha).toISOString().split('T')[0] : ''}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.id_1_1_1_p_nombre ?? row.id111PNombre}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.id_1_1_2_s_nombre ?? row.id112SNombre}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.id_1_1_3_p_apellido ?? row.id113PApellido}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.id_1_1_4_s_apellido ?? row.id114SApellido}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.tipo_documento ?? row.id_1_2_1_tipo_documento}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.id_1_2_2_n_documento ?? row.id122NDocumento}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.comuna_arribo ?? row.comunaArribo}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.barrio_arribo}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.ubi_3_3_asentamiento_o_sector ?? row.ubi33AsentamientoOSector}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.ubi_3_4_direccion ?? row.ubi34Direccion}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.departamento_hecho ?? row.departamentoHecho}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.municipio_hecho ?? row.municipioHecho}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_4_3_subregion_antioquia ?? row.vict443SubregionAntioquia}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.lugar_exacto ?? row.lugarExacto}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_4_5_nombre_tipo_entorno ?? row.vict445NombreTipoEntorno}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.tipo_movilidad ?? row.tipoMovilidad}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.comuna_hecho ?? row.comunaHecho}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.barrio_hecho ?? row.barrioHecho}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_4_9_hecho_intraurbano_sector_o_asentamiento ?? row.vict449HechoIntraurbanoSectorOAsentamiento}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_4_10_hecho_intraurbano_direccion ?? row.vict4410HechoIntraurbanoDireccion}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_5_fecha_hecho ? new Date(row.vict_4_5_fecha_hecho).toISOString().split('T')[0] : ''}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_1_3_desplazamiento_forzado}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_1_4_homicidio}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_1_5_masacre}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_1_6_tortura_o_tratos_inhumanos_degradantes}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_1_7_lesiones_permanentes_o_transitorias}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_1_8_minas_antipersonal_municiones_sin_explotar}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_1_10_1_intento_de_reclutamiento}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_1_10_2_reclutamiento_y_utilizacion}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_1_11_acto_terrorista}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_1_12_amenaza}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_1_13_despojo_y_abandono_forzado_de_tierras}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.actor_armado1}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.actor_armado2}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar}</td>
                                                    <td className={row.id === filaSeleccionada ? 'selected-row' : ''}>{row.dx_7_1_nombre_responsable_atencion}</td>
                                                </tr>
                                                ))
                                            )}
                                            </tbody>
                                        </table>
                                        </div>
                                </div>
                                
                            </div>
                            {infoModal.show && <div className="tab-pane active" id="tab_revision">
                                <h4>Revision de diagnostico base</h4>
                                <form className="form-horizontal" onSubmit={handleSubmit(guardarDxRevision)}>
                                    <Row>
                                    <Col>
                                        <b>ID:</b> {infoModal.content.id}{" "}
                                        <b>FECHA:</b> {infoModal.content.dx_fecha?.split('T')[0] ?? infoModal.content.dx_fecha} ,{" "}
                                        <b>NOMBRES:</b> {infoModal.content.id_1_1_1_p_nombre}{" "}
                                        {infoModal.content.id_1_1_2_s_nombre}{" "}
                                        {infoModal.content.id_1_1_3_p_apellido}{" "}
                                        {infoModal.content.id_1_1_4_s_apellido},{" "}
                                        <b> DOCUMENTO:</b> {infoModal.content.id_1_2_2_n_documento}
                                        <b> RESPONSABLE:</b> {infoModal.content.dx_7_1_nombre_responsable_atencion}
                                    </Col>
                                    </Row>
                                    <Row>
                                    <Col>
                                        <InputGroup className="mb-2">
                                        <InputGroup.Text>FECHA HECHO:</InputGroup.Text>
                                        <DatePicker
                                            selected={fechaHechoDate}
                                            onChange={date => setValue('vict_4_5_fecha_hecho', date ? moment(date).format('YYYY-MM-DD') : '')}
                                            className="form-control"
                                            dateFormat="yyyy-MM-dd"
                                            placeholderText="Seleccione fecha"
                                        />
                                        </InputGroup>
                                        {errors.vict_4_5_fecha_hecho && <span className="text-danger">Fecha del hecho es requerida</span>}
                                    </Col>
                                    </Row>
                                    <Row>
                                    <Col>
                                        <InputGroup>
                                        <InputGroup.Text>MUNICIPIO:</InputGroup.Text>
                                        <Form.Select
                                            className="form-control"
                                            value={vict_4_4_2_municipio}
                                            onChange={e => {
                                                setValue('vict_4_4_2_municipio', e.target.value)
                                                const departamento = municipios.find(m => m.id === e.target.value)?.mun_departamento || '';
                                                setValue('vict_4_4_1_departamento', municipios.find(m => m.id === e.target.value)?.mun_departamentoid || '')
                                                setValue('departamentoHecho', departamento)
                                                setValue('vict_4_4_3_subregion_antioquia', municipios.find(m => m.id === e.target.value)?.mun_subregion || '')
                                                setValue('vict_4_4_6_tipo_movilidad', setTipoMovilidad(municipios.find(m => m.id === e.target.value)?.mun_departamentoid || '', e.target.value).toString())
                                            }}
                                            required
                                        >
                                            <option value="">Seleccione municipio</option>
                                            {municipios.map(municipio => (
                                            <option key={municipio.id} value={municipio.id}>{municipio.mun_municipio} - {municipio.mun_departamento}</option>
                                            ))}
                                        </Form.Select>
                                        </InputGroup>
                                        {errors.vict_4_4_2_municipio && <span className="text-danger">Municipio es requerido</span>}
                                    </Col>
                                    <Col>
                                        <b> DEPARTAMENTO: </b> {watch('departamentoHecho')},{" "}
                                        <b> SUBREGION: </b> {municipios.find( m => m.id === vict_4_4_2_municipio.toString())?.mun_subregion || ''}
                                        <b> TIPO MOVILIDAD: </b> {tiposMovilidad.find(tm => tm.id === watch('vict_4_4_6_tipo_movilidad').toString())?.nombre || ''}
                                    </Col>
                                    </Row>
                                    <Row>
                                    <Col>
                                        <InputGroup>
                                        <InputGroup.Text>LUGAR EXACTO:</InputGroup.Text>
                                        <Form.Select
                                            className="form-control"
                                            value={vict_4_4_4_lugar_exacto_del_municipio || ''}
                                            onChange={e => setValue('vict_4_4_4_lugar_exacto_del_municipio', e.target.value)}
                                        >
                                            <option value="">Seleccione lugar exacto</option>
                                            {lugarExacto.map(opt => (
                                            <option key={opt.id} value={opt.id}>{opt.nombre}</option>
                                            ))}                                            
                                        </Form.Select>
                                        </InputGroup>
                                        {errors.vict_4_4_4_lugar_exacto_del_municipio && <span className="text-danger">Lugar exacto es requerido</span>}
                                    </Col>
                                    <Col>
                                        <InputGroup>
                                        <InputGroup.Text>ENTORNO:</InputGroup.Text>
                                        <Form.Control
                                            value={vict_4_4_5_nombre_tipo_entorno || ''}
                                            onChange={e => setValue('vict_4_4_5_nombre_tipo_entorno', e.target.value)}
                                        />
                                        </InputGroup>
                                        {errors.vict_4_4_5_nombre_tipo_entorno && <span className="text-danger">Entorno es requerido</span>}
                                    </Col>
                                    </Row>
                                    <Row>
                                    <h5>Ubicaci&oacute;n del hecho intraurbano</h5>
                                    <Col>
                                        <InputGroup>
                                        <InputGroup.Text>BARRIO:</InputGroup.Text>
                                        <Form.Select
                                            className="form-control"
                                            value={vict_4_4_8_hecho_intraurbano_barrio || ''}
                                            onChange={e => {
                                                setValue('vict_4_4_8_hecho_intraurbano_barrio', e.target.value)
                                                setValue('vict_4_4_7_hecho_intraurbano_comuna_o_corregimiento', barrios.find(b => b.id === e.target.value)?.idcomuna || '')
                                            }}
                                        >
                                            <option value="">Seleccione barrio</option>
                                            {barrios.map(barrio => (
                                            <option key={barrio.id} value={barrio.id}>{barrio.barrio}</option>
                                            ))}
                                        </Form.Select>
                                        </InputGroup>
                                    </Col>
                                    <Col>
                                        <b>COMUNA:</b> {watch('vict_4_4_7_hecho_intraurbano_comuna_o_corregimiento')} - {barrios.find(b => b.id === vict_4_4_8_hecho_intraurbano_barrio.toString())?.comuna || ''}
                                    </Col>
                                    </Row>
                                    <Row>
                                    <Col>
                                        <InputGroup>
                                        <InputGroup.Text>SECTOR INTRAURBANO:</InputGroup.Text>
                                        <Form.Control
                                            value={vict_4_4_9_hecho_intraurbano_sector_o_asentamiento || ''}
                                            onChange={e => setValue('vict_4_4_9_hecho_intraurbano_sector_o_asentamiento', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    <Col>
                                        <InputGroup>
                                        <InputGroup.Text>DIRECCION:</InputGroup.Text>
                                        <Form.Control
                                            value={vict_4_4_10_hecho_intraurbano_direccion || ''}
                                            onChange={e => setValue('vict_4_4_10_hecho_intraurbano_direccion', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    </Row>
                                    <Row>
                                    <h5>Ubicaci&oacute;n arribo</h5>
                                    <Col>
                                        <InputGroup>
                                        <InputGroup.Text>BARRIO:</InputGroup.Text>
                                        <Form.Select
                                            className="form-control"
                                            value={ubi_3_2_barrio_o_vereda}
                                            onChange={e => {
                                                setValue('ubi_3_2_barrio_o_vereda', e.target.value)
                                                setValue('ubi_3_1_comuna_o_corregimiento', barrios.find(b => b.id === e.target.value)?.id || '')
                                            }}
                                            required
                                        >
                                            <option value="">Seleccione barrio</option>
                                            {barrios.map(barrio => (
                                            <option key={barrio.id} value={barrio.id}>{barrio.barrio}</option>
                                            ))}
                                        </Form.Select>
                                        </InputGroup>
                                    </Col>
                                    <Col>
                                        <b>COMUNA:</b> {watch('ubi_3_1_comuna_o_corregimiento')} - {barrios.find(b => b.id === ubi_3_2_barrio_o_vereda.toString())?.comuna || ''}  
                                    </Col>
                                    </Row>
                                    <Row>
                                    <Col>
                                        <InputGroup>
                                        <InputGroup.Text>SECTOR INTRAURBANO:</InputGroup.Text>
                                        <Form.Control
                                            value={ubi_3_3_asentamiento_o_sector || ''}
                                            onChange={e => setValue('ubi_3_3_asentamiento_o_sector', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    <Col>
                                        <InputGroup>
                                        <InputGroup.Text>DIRECCION:</InputGroup.Text>
                                        <Form.Control
                                            value={ubi_3_4_direccion || ''}
                                            onChange={e => setValue('ubi_3_4_direccion', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    </Row>
                                    <Row>
                                    <h5>Actor armados responsables</h5>
                                    <Col>
                                        <InputGroup>
                                        <InputGroup.Text>ACTOR ARMADO 1:</InputGroup.Text>
                                        <Form.Select
                                            className="form-control"
                                            value={vict_4_2_actor_armado_ocasiono_el_hecho_victimizante}
                                            onChange={e => setValue('vict_4_2_actor_armado_ocasiono_el_hecho_victimizante', e.target.value)}
                                        >
                                            <option value="">Seleccione actor</option>
                                            {actoresarmados.map(actor => (
                                            <option key={actor.id} value={actor.id}>{actor.nombre}</option>
                                            ))}
                                        </Form.Select>
                                        </InputGroup>
                                    </Col>
                                    <Col>
                                        <InputGroup>
                                        <InputGroup.Text>ACTOR ARMADO 2:</InputGroup.Text>
                                        <Form.Select
                                            className="form-control"
                                            value={vict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante}
                                            onChange={e => setValue('vict_4_2_1_actor_armado_ocasiono_el_hecho_victimizante', e.target.value)}
                                        >
                                            <option value="">Seleccione actor</option>
                                            {actoresarmados.map(actor => (
                                            <option key={actor.id} value={actor.id}>{actor.nombre}</option>
                                            ))}
                                        </Form.Select>
                                        </InputGroup>
                                    </Col>
                                    <Col>
                                        <InputGroup>
                                        <InputGroup.Text>OTRO ACTOR ARMADO</InputGroup.Text>
                                        <Form.Control
                                            value={vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar || ''}
                                            onChange={e => setValue('vict_4_2_1_1_si_la_respuesta_anterior_es_otros_cual_identificar', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    </Row>
                                    <Row>
                                    <h5>Hechos declarados</h5>
                                    </Row>
                                    <Row>
                                    <Col md={3}>
                                        <InputGroup>
                                        <InputGroup.Text>Desplazamiento</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            min="0"
                                            max="1"
                                            value={vict_4_1_3_desplazamiento_forzado || '0'}
                                            onChange={e => setValue('vict_4_1_3_desplazamiento_forzado', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    <Col md={3}>
                                        <InputGroup>
                                        <InputGroup.Text>Homicidio</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            min="0"
                                            max="1"
                                            value={vict_4_1_4_homicidio || '0'}
                                            onChange={e => setValue('vict_4_1_4_homicidio', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    <Col md={3}>
                                        <InputGroup>
                                        <InputGroup.Text>Masacre</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            min="0"
                                            max="1"
                                            value={vict_4_1_5_masacre || '0'}
                                            onChange={e => setValue('vict_4_1_5_masacre', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    <Col md={3}>
                                        <InputGroup>
                                        <InputGroup.Text>Tortura</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            min="0"
                                            max="1"
                                            value={vict_4_1_6_tortura_o_tratos_inhumanos_degradantes || '0'}
                                            onChange={e => setValue('vict_4_1_6_tortura_o_tratos_inhumanos_degradantes', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    <Row>
                                    <Col md={3}>
                                        <InputGroup>
                                        <InputGroup.Text>Lesiones</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            min="0"
                                            max="1"
                                            value={vict_4_1_7_lesiones_permanentes_o_transitorias || '0'}
                                            onChange={e => setValue('vict_4_1_7_lesiones_permanentes_o_transitorias', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    <Col md={3}>
                                        <InputGroup>
                                        <InputGroup.Text>Minas</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            min="0"
                                            max="1"
                                            value={vict_4_1_8_minas_antipersonal_municiones_sin_explotar || '0'}
                                            onChange={e => setValue('vict_4_1_8_minas_antipersonal_municiones_sin_explotar', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    <Col md={3}>
                                        <InputGroup>
                                        <InputGroup.Text>Delito sexual</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            min="0"
                                            max="1"
                                            value={vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual || '0'}
                                            onChange={e => setValue('vict_4_1_9_delitos_contra_la_libertad_y_la_integridad_sexual', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    <Col md={3}>
                                        <InputGroup>
                                        <InputGroup.Text>Intento reclutamiento</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            min="0"
                                            max="1"
                                            value={vict_4_1_10_1_intento_de_reclutamiento || '0'}
                                            onChange={e => setValue('vict_4_1_10_1_intento_de_reclutamiento', e.target.value)   
                                            }
                                        />
                                        </InputGroup>
                                    </Col>
                                    </Row>
                                    <Row>
                                    <Col md={3}>
                                        <InputGroup>
                                        <InputGroup.Text>Reclutamiento</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            min="0"
                                            max="1"
                                            value={vict_4_1_10_2_reclutamiento_y_utilizacion || '0'}
                                            onChange={e => setValue('vict_4_1_10_2_reclutamiento_y_utilizacion', e.target.value)
                                            }
                                        />
                                        </InputGroup>
                                    </Col>
                                    <Col md={3}>
                                        <InputGroup>
                                        <InputGroup.Text>Acto terrorista</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            min="0"
                                            max="1"
                                            value={vict_4_1_11_acto_terrorista || '0'}
                                            onChange={e => setValue('vict_4_1_11_acto_terrorista', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    <Col md={3}>
                                        <InputGroup>
                                        <InputGroup.Text>Amenaza</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            min="0"
                                            max="1"
                                            value={vict_4_1_12_amenaza || '0'}
                                            onChange={e => setValue('vict_4_1_12_amenaza', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    <Col md={3}>
                                        <InputGroup>
                                        <InputGroup.Text>Abandono</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            min="0"
                                            max="1"
                                            value={vict_4_1_13_despojo_y_abandono_forzado_de_tierras || '0'}
                                            onChange={e => setValue('vict_4_1_13_despojo_y_abandono_forzado_de_tierras', e.target.value)}
                                        />
                                        </InputGroup>
                                    </Col>
                                    </Row>
                                    <Col>
                                        <b>Observaciones: </b>
                                        <p>{vict_4_7_observaciones}</p>
                                    </Col>
                                    </Row>
                                    <br />
                                    <Row className="justify-content-end">
                                    <Col md={3}>
                                        <Button variant="primary" type="submit">Guardar</Button>
                                    </Col>
                                    </Row>
                                </form>
                                
                            
                            </div>}
                            
                        </div>
                    </div>
                    </div>
                </div>    
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
        
    )
  }